"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectListConverter_1 = require("../core/conversions/DataObjectListConverter");

var AppModule_1 = require("../core/modules/AppModule");

var ForecastCoordinatorTreeDataDTOConverterImpl_1 = require("./conversions/ForecastCoordinatorTreeDataDTOConverterImpl");

var ForecastCoordinatorUpdateDTOConverter_1 = require("./conversions/ForecastCoordinatorUpdateDTOConverter");

var ForecastCoordinatorUpdateDTOConverterImpl_1 = require("./conversions/ForecastCoordinatorUpdateDTOConverterImpl");

var ForecastCoordinatorTreeDataDTO_1 = require("./model/ForecastCoordinatorTreeDataDTO");
/**
 * @author OPt
 */


var ForecastCoordinatorAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ForecastCoordinatorAppModule, _AppModule_1$AppModul);

  function ForecastCoordinatorAppModule() {
    var _this;

    _classCallCheck(this, ForecastCoordinatorAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'forecastCoordinatorAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastCoordinatorAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ForecastCoordinatorUpdateDTOConverter_1.ForecastCoordinatorUpdateDTOConverter).to(ForecastCoordinatorUpdateDTOConverterImpl_1.ForecastCoordinatorUpdateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectListConverter_1.DataObjectListConverter, {
        className: ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.name
      }).to(ForecastCoordinatorTreeDataDTOConverterImpl_1.ForecastCoordinatorTreeDataDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ForecastCoordinatorAppModule;
}(AppModule_1.AppModule);

exports.ForecastCoordinatorAppModule = ForecastCoordinatorAppModule;